<template>
  <div id="register" class="signUpEmail">
    <div class="header">
        <p>Register to customise your experience and manage your notifications.</p>
    </div>
		<div class="loginForm">
      <h1>REGISTER</h1>
      <div class="input">
          <input type="text" required v-model="emailform.name" placeholder="Name">
          <label class="sr-only">Name</label>
      </div>
      <div class="input">
          <input type="text" required v-model="emailform.email" placeholder="Email">
          <label class="sr-only">Email</label>
      </div>
      <div class="input">
          <input class="password" type="password" required v-model="emailform.password" placeholder="Password">
          <label class="sr-only">Password</label>
      </div>
      <button class="btn submitBtn" @click="emailRegister">Register</button>
    </div>
    <button class="btn backBtn" @click="$router.push({ path: '/login' })"><i class="icon-left-open"></i>Back to Login</button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'email-register',
  props: ['setloading'],
  data: function () {
    return {
      emailform: {
        'name': '',
        'email': '',
        'password': ''
      }
    }
  },
  methods: {
    emailRegister: function () {
      let payload = {
        name: this.emailform.name,
        email: this.emailform.email,
        password: this.emailform.password
      }
      this.setloading(true)
      this.RegisterByEmail(payload)
        .then((response) => {
          this.setloading(false)
          this.getUserInfo()
            .then((response) => {
              this.getWeatherData(this.$store.state.user.profile.weather_region_id).then((response) => {
                this.$nextTick(function () {
                  this.$router.push('/')
                })
              })
            })
        })
        .catch((error) => {
          window.alertify.error('There was a problem with your registration. Please try again. (Error: ' + error.response.data.message + ')')
          this.setloading(false)
        })
    },
    ...mapActions([
      'RegisterByEmail', 'getUserInfo', 'getWeatherData'
    ])
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/login/Register.vue